module.exports = __webpack_public_path__ + "static/img/dxtc.91c77bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dxtc.jpg
// module id = +fBT
// module chunks = 1